// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__zScxd","alert":"SettungsInbox_alert__DWGve"};